import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import AgePopup from "./components/AgePopup";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import BottomNav from "./components/BottomNav";
import Cart from "./components/Cart"; // <-- ADD THIS

function App() {
  const [cartOpen, setCartOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true); // login temp (replace later)

  return (
    <Router>
      <div className="bg-gray-100 min-h-screen pb-20">

        <AgePopup />

        {/* NAVBAR — send openCart function */}
        <Navbar
          isLoggedIn={isLoggedIn}
          openCart={() => setCartOpen(true)}
        />

        {/* PAGE CONTENT */}
        <div className="pt-24 px-4">
          <Home />
        </div>

        {/* BOTTOM NAV */}
        <BottomNav />

        {/* FOOTER */}
        <Footer />

        {/* CART DRAWER */}
        {isLoggedIn && (
          <Cart isOpen={cartOpen} onClose={() => setCartOpen(false)} />
        )}

      </div>
    </Router>
  );
}

export default App;
